import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { IOrders } from '../../../services/hooks/orders';
import { CloseButton, Container, Content } from './styles';

interface IProps {
  order?: IOrders;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  modalOpen: boolean;
}

interface DetailDebs {
  ipva: Array<any>;
  multas: Array<any>;
  licenciamento: Array<any>;
  outros: Array<any>;
}

const ModalOrderDetails = ({ order, setModalOpen, modalOpen }: IProps) => {
  const [debtsDetail, setDebtsDetail] = useState<DetailDebs>({
    ipva: [],
    multas: [],
    licenciamento: [],
    outros: [],
  });

  const handletest = () => {
    const debitos = order?.payloadCaptura?.debitos;
    const resultados: any = {};

    debitos.forEach((debt: any) => {
      const code = debt.codigo;

      Object.keys(order?.dataConsulta?.debitos).forEach((chave: any) => {
        if (!resultados[chave]) {
          resultados[chave] = [];
        }

        if (Array.isArray(order?.dataConsulta?.debitos[chave])) {
          order?.dataConsulta?.debitos[chave].forEach((item: any) => {
            if (item.codigo === code) {
              resultados[chave].push(item);
            }
          });
        }
      });
    });

    setDebtsDetail(resultados);
  };

  useEffect(() => {
    if (order && order.payloadCaptura?.debitos) {
      handletest();
    }
  }, [order]);

  useEffect(() => {
    const handleKeyPress = (e: any) => {
      if (modalOpen && e.key === 'Escape') {
        setModalOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [modalOpen, setModalOpen]);

  if (!modalOpen) return null;

  return (
    <Container onClick={() => setModalOpen(false)}>
      <Content>
        <h1>Detalhes do Pedido</h1>
        {order?.dataConsulta?.debitos ? (
          <div className="details">
            {debtsDetail?.ipva && debtsDetail.ipva.length > 0 && (
              <div className="detailContainer">
                <h4>IPVA</h4>
                {debtsDetail.ipva.map((ipva: any) => (
                  <div key={ipva.codigo} className="detailContainerDebt">
                    <p>{ipva.descricao}</p>
                    <p>
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(ipva.valor)}
                    </p>
                  </div>
                ))}
              </div>
            )}
            {debtsDetail?.multas && debtsDetail?.multas.length > 0 && (
              <div className="detailContainer">
                <h4>MULTAS</h4>
                {debtsDetail.multas.map((multa: any) => (
                  <div key={multa.codigo} className="detailContainerDebt">
                    <p>{multa.descricao}</p>
                    <p>
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(multa.valor)}
                    </p>
                  </div>
                ))}
              </div>
            )}
            {debtsDetail?.licenciamento &&
              debtsDetail?.licenciamento.length > 0 && (
                <div className="detailContainer">
                  <h4>LICENCIAMENTO</h4>
                  {debtsDetail.licenciamento.map((licenciamento: any) => (
                    <div
                      key={licenciamento.codigo}
                      className="detailContainerDebt"
                    >
                      <p>{licenciamento.descricao}</p>
                      <p>
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(licenciamento.valor)}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            {debtsDetail?.outros && debtsDetail?.outros.length > 0 && (
              <div className="detailContainer">
                <h4>OUTROS</h4>
                {debtsDetail.outros.map((outros: any) => (
                  <div key={outros.codigo} className="detailContainerDebt">
                    <p>{outros.descricao}</p>
                    <p>
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(outros.valor)}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div>
            <span>Este pedido não tem nenhum débito</span>
          </div>
        )}
        <CloseButton type="button" onClick={() => setModalOpen(false)}>
          FECHAR
        </CloseButton>
      </Content>
    </Container>
  );
};

export { ModalOrderDetails };
